var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noData"},[_c('div',{staticClass:"trainlistImg"},[_c('img',{attrs:{"src":"/image/personal/time.png","alt":""}}),_c('p',[_c('span',[_vm._v("无相关信息")])])])])
}]

export { render, staticRenderFns }